function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}


const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}









function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    if (count === 0) {
      el.classList.add("hide");
    } else {
      el.classList.remove("hide");
      el.textContent = count;
    }
  });
}


// ✅ Barre de progression dynamique (2 étapes)
function updateOfferProgressBar(cart) {
  const container = document.getElementById("offer-progress");
  if (!container) return;

  const count = cart.item_count;
  const messageEl = document.getElementById("offer-progress-message");
  const circle1 = document.getElementById("step-1");
  const circle2 = document.getElementById("step-2");
  const line = document.getElementById("offer-line");

  // Reset
  [circle1, circle2].forEach(el => el?.classList.remove("completed"));
  line?.classList.remove("completed");

  // Cacher si panier vide
  if (count === 0) {
    container.style.display = "none";
    return;
  }

  container.style.display = "block";

  // Mise à jour progression
  if (count < 2) {
    if (messageEl) {
      messageEl.textContent = `Plus que ${2 - count} article${(2 - count) > 1 ? 's' : ''} pour bénéficier d'une toile offerte`;
    }
    circle1?.classList.add("completed");
  } else {
    if (messageEl) {
      messageEl.textContent = `🎉 Bravo ! Une toile offerte sera ajoutée`;
    }
    circle1?.classList.add("completed");
    circle2?.classList.add("completed");
    line?.classList.add("completed");
  }
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();

  // Recalcul de la barre dynamique
  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();
  updateOfferProgressBar(cart);
}
async function ajaxUpdateCart(key, newQuantity){
  const res = await fetch("/cart/update.js", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates: { [key]: newQuantity } }),
  });
  const cart = await res.json();

  updateCartItemCounts(cart.item_count);
  updateOfferProgressBar(cart); // 🔁 mise à jour live

  // Mettre à jour drawer HTML
  updateCartDrawer();
}
function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", () => {
        // Get line item key
        const rootItem = button.closest('.cart-drawer-item');
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update
        rootItem.classList.add('loading');
        ajaxUpdateCart(key, newQuantity);
      });
    });
  // remove item
  document.querySelectorAll(".cart-drawer-remove")
    .forEach((button)=>{
      button.addEventListener("click", ()=>{
        const rootItem = button.closest('.cart-drawer-item');
        const key = rootItem.getAttribute("data-line-item-key");
        // Ajax update
        rootItem.classList.add('loading');
        ajaxUpdateCart(key, 0);
        
      })
    })
  

  // Fermer drawer au clic hors zone
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

// Formulaires ajout au panier
/*
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    var loader = form.querySelector('.loader');
    
    // Envoi AJAX
    if(loader) loader.classList.remove('hidden');
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Récupérer panier
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);
    updateOfferProgressBar(cart); // 🔁 live update

    // Mettre à jour le drawer
    await updateCartDrawer();

    // Ouvrir le drawer
    openCartDrawer();
    if(loader) loader.classList.add('hidden');
  });
});
*/
document.addEventListener('product-form--submitted', async (e)=>{
  var form = document.querySelector('form[action="/cart/add"]');
  var loader = form.querySelector('.loader');
  // Récupérer panier
  if(loader) loader.classList.remove('hidden');
  const res = await fetch("/cart.js");
  const cart = await res.json();
  updateCartItemCounts(cart.item_count);
  updateOfferProgressBar(cart); // 🔁 live update

  // Mettre à jour le drawer
  await updateCartDrawer();

  // Ouvrir le drawer
  openCartDrawer();
  if(loader) loader.classList.add('hidden');
})

// Liens vers /cart => ouvrent drawer
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});




















//predictive search
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.closeBtn = this.querySelector('.drawer__search-close');
    this.submitBtn = this.querySelector('.drawer__search-submit');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    //this.addEventListener('focusout', this.onFocusOut.bind(this));
    // this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
    this.closeBtn?.addEventListener('click', this.close.bind(this));
    document.addEventListener('click', (event) => {
      if (!event.target.closest('predictive-search')) {
        this.close();
      }
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.close(false, false);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    console.log('focusout');
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    return;
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
   // this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.top = `${this.getBoundingClientRect().bottom+5}px`;
    this.predictiveSearchResults.style.left = `${this.getBoundingClientRect().left}px`;
    this.predictiveSearchResults.setAttribute('open', true);
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  show() {
    this.setAttribute('open', true);
    setTimeout(function(){ $('.drawer__search-input'). focus (); }, 500);
  }

  close(clearSearchTerm = false, complete=true) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      console.log('closed 2');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.predictiveSearchResults.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
    if(complete){
      this.removeAttribute('open');
      this.isOpen = false;
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
